import { render, staticRenderFns } from "./DownloadDetail.vue?vue&type=template&id=3b0ad7b2&scoped=true"
import script from "./DownloadDetail.vue?vue&type=script&lang=js"
export * from "./DownloadDetail.vue?vue&type=script&lang=js"
import style0 from "./DownloadDetail.vue?vue&type=style&index=0&id=3b0ad7b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0ad7b2",
  null
  
)

export default component.exports